// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f08daadc","488":"bceeba26","732":"bd3bd1b5","977":"c897df0a"}[chunkId] + ".chunk.js";
};